import {
  createFiduciarioListItemModel,
  extractRicercaFiduciariItems,
  normalizeFiduciariConfigModel,
} from './fiduciari.models';

export const normalizeFiduciariConfig = (data = {}) => normalizeFiduciariConfigModel(data);

export const safeString = (value) => (value === null || value === undefined ? '' : value.toString().trim());

const buildAddress = (indirizzoCompleto = {}) => {
  const { via, comune, provincia, cap } = indirizzoCompleto || {};
  return [via, comune, provincia, cap].filter(Boolean).join(', ') || '-';
};

export const normalizeFiduciarioItem = (item, suPortale) => {
  const anagrafica = item?.anagrafica || {};
  const displayName = anagrafica.cognomeRagioneSociale
    || [anagrafica.nome, anagrafica.cognome].filter(Boolean).join(' ')
    || '-';

  const competenze = Array.isArray(item?.competenze) ? item.competenze : [];
  const specializzazioni = Array.isArray(item?.specializzazioni) ? item.specializzazioni : [];
  const competenzaLabel = competenze.map((c) => c?.descrizione || c?.codice).filter(Boolean).join(', ');
  const specializzazioneLabel = specializzazioni.map((s) => s?.descrizione || s?.codice).filter(Boolean).join(', ');

  return {
    ...item,
    soggetto: {
      nome: anagrafica.nome || null,
      cognome: anagrafica.cognome || null,
      denominazione: displayName,
      codiceFiscale: anagrafica.codiceFiscale || '',
      partitaIva: anagrafica.partitaIva || '',
      email: anagrafica.email || '',
      telefono: anagrafica.telefono || '',
      indirizzo: buildAddress(anagrafica.indirizzoCompleto),
    },
    competenza: competenzaLabel || '-',
    specializzazione: specializzazioneLabel || '-',
    accordoQuadro: item?.accordoQuadro ?? false,
    correlato: item?.correlato ?? false,
    note: item?.note || '-',
    suPortale: suPortale === 'SI',
  };
};

const normalizePortalTrusteeItem = (trustee = {}) => createFiduciarioListItemModel({
  // Portal exposes a trustee technical id (e.g. "17") that is not an OS UUID.
  // Keep it separate from the canonical FE id so it is never reused as incaricatoId.
  id: trustee?.idFiduciario ? `portal:${trustee.idFiduciario}` : `portal:${crypto.randomUUID()}`,
  codiceFiduciario: trustee?.idFiduciario || trustee?.id || '',
  soggetto: {
    nome: null,
    cognome: null,
    denominazione: trustee?.name || '-',
    codiceFiscale: '',
    partitaIva: '',
    email: trustee?.email || '',
    telefono: trustee?.phone || '',
    indirizzo: trustee?.address || '-',
  },
  accordoQuadro: true,
  suPortale: true,
  portal: true,
  attivo: trustee?.isActive ?? true,
  externalId: trustee?.idFiduciario || null,
  portalRawId: trustee?.id || null,
});

export const normalizeRicercaFiduciariResponse = (res, suPortale) => {
  const { source, items } = extractRicercaFiduciariItems(res?.data);

  if (source === 'portalTrustees') {
    return items.map((item) => normalizePortalTrusteeItem(item));
  }

  return items.map((item) => normalizeFiduciarioItem(item, suPortale));
};
